import type { ReactNode } from 'react'

// ช่องกรอก/ป้ายชื่อมาตรฐานของฟอร์มในหน้าบัญชี (โปรไฟล์ ฯลฯ) — ใช้ร่วมกันให้หน้าตาเหมือนกันทุกฟอร์ม
export const inputClass =
  'flex h-12 w-full border border-[#E7E5F0] bg-white px-3.5 text-sm text-[#19172A] transition-colors placeholder:text-[#69738A]/70 focus-visible:border-accent focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-accent/15'

export const textareaClass =
  'flex w-full resize-none border border-[#E7E5F0] bg-white px-3.5 py-3 text-sm text-[#19172A] transition-colors placeholder:text-[#69738A]/70 focus-visible:border-accent focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-accent/15'

export const readonlyInputClass =
  'flex h-12 w-full cursor-not-allowed border border-[#E7E5F0] bg-[#F7F7FA] px-3.5 text-sm text-[#69738A]'

export function Field({ label, htmlFor, required, hint, children }: {
  label: string
  htmlFor: string
  required?: boolean
  hint?: string
  children: ReactNode
}) {
  return (
    <div className="space-y-1.5">
      <label htmlFor={htmlFor} className="text-sm font-medium text-[#19172A]">
        {label}{required && <span className="ml-0.5 text-rose-500">*</span>}
      </label>
      {children}
      {hint && <p className="text-xs text-[#69738A]">{hint}</p>}
    </div>
  )
}
